module.exports = __webpack_public_path__ + "img/layer-forward.e8da3a8e.svg";